import React from 'react'
import { UserDetailFormAdminStyle } from './styled'
import {
  Button,
  Image,
  Input,
  Section,
  SelectBox,
  Switcher,
  Spinner,
} from '../../components'
import { ICONS } from '../../themes'
import { ROUTE_PATH, STRING } from '../../helpers'
import { EMAIL_REGEX } from 'helpers'
import { usermanageController } from '../../apiService'
import { trimmedString } from '../../helpers/functions/strRemoveWhiteSpace'
import { toastActive } from '../../helpers/functions/toastSuccess'
import { toastFail } from '../../helpers/functions/toastFail'

export class UserDetailFormAdminContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      optionsRole: [
        { value: '1', label: 'Admin' },
        // { value: '4', label: 'User' },
      ],
      optionsRoleValue: null,
      isEditPageState: false,
      isActive: true,
      name: '',
      email: '',
      phone: '',
      nameValid: false,
      emailValid: false,
      phoneValid: false,
      roleValid: false,
      formValid: true,
      disabledSubmit: false,
    }
  }

  handleUserInput = e => {
    const { name, value } = e.target
    this.setState({ [name]: value }, () => {
      this.validateField(name, value.trim())
      //console.log('value!!!!!!!!!!!!!!!', value.trim())
    })
  }

  handleUserDropdown = optionsRole => {
    this.setState({ optionsRoleValue: optionsRole, roleValid: false }, () => {
      this.validateField(optionsRole.label, optionsRole.value)
      //console.log('value!!!!!!!!!!!!!!!', optionsRole.value)
    })
  }

  validateField = (fieldName, value) => {
    let nameValid = this.state.nameValid
    let emailValid = this.state.emailValid
    let phoneValid = this.state.phoneValid
    let roleValid = this.state.roleValid

    switch (fieldName) {
      case 'name':
        nameValid = value.length !== 0
        this.setState({ nameValid: nameValid })
        break
      case 'email':
        emailValid = RegExp(EMAIL_REGEX).test(value)
        //console.log('emailValid', emailValid)
        this.setState({ emailValid: emailValid })
        break
      case 'phone':
        phoneValid = value.length !== 0
        this.setState({ phoneValid: phoneValid })
        break
      case 'role':
        this.state.optionsRoleValue === null
        this.setState({ roleValid: roleValid })
        break
      default:
        break
    }
  }

  onFormSubmit = e => {
    e.preventDefault()
    if (this.state.optionsRoleValue === null) {
      this.setState({
        roleValid: true,
      })
    } else {
      this.setState({
        roleValid: false,
      })
    }
    //console.log('this.state.optionsRoleValue', this.state.optionsRoleValue)
    if (
      this.state.nameValid &&
      this.state.emailValid &&
      this.state.phoneValid &&
      this.state.optionsRoleValue
    ) {
      this.setState(
        {
          formValid: true,
          disabledSubmit: true,
        },
        () =>
          usermanageController()
            .createUserAdmin({
              full_name: trimmedString(this.state.name),
              email: trimmedString(this.state.email),
              phone: trimmedString(this.state.phone),
              role: parseInt(this.state.optionsRoleValue.value, 10),
            })
            .then(res => {
              if (res) {
                if (res.status === 'EmailDuplicate') {
                  toastFail('Email duplicate please change email')
                } else if (res.status === 'SendMailSuccess') {
                  toastActive('Create was successes')
                }
              }
            })
            .finally(() =>
              this.props.history.push(ROUTE_PATH.USER_MANAGEMENT_ADMIN.LINK)
            )
      )
    } else {
      this.setState({
        formValid: false,
        disabledSubmit: false,
      })
    }
  }

  render() {
    const { optionsRole, isEditPageState, isActive } = this.state

    return (
      <UserDetailFormAdminStyle>
        {/* PAGE TITLE
        -----------------------------------------------------
        -----------------------------------------------------
        */}
        <Section className="page-topbar">
          <Section className="page-header">
            <Section className="page-icon">
              <Image
                id="page_icon_user_form"
                src={ICONS['icon-user-white.svg']}
                alt="page icon"
              />
            </Section>

            <Section className="title-and-breadcrumb">
              <Section id="page_title_user_form" className="title">
                User Management
              </Section>

              <Section id="page_breadcrumb_user_form" className="breadcrumbs">
                <Button
                  className="breadcrumb"
                  onClick={() => {
                    this.props.history.push(ROUTE_PATH.HOME.LINK)
                  }}
                >
                  <span>{STRING.HOME}</span>
                </Button>

                <Button
                  onClick={() => {
                    this.props.history.push(
                      ROUTE_PATH.USER_MANAGEMENT_ADMIN.LINK
                    )
                  }}
                  className="breadcrumb"
                >
                  <span>User Management</span>
                </Button>

                <Button className="breadcrumb current">
                  <span>Create User</span>
                </Button>
              </Section>
            </Section>
          </Section>
        </Section>

        {/* PAGE CONTENT
        -----------------------------------------------------
        -----------------------------------------------------
        */}
        <Section className="main-content form">
          <Section className="content-body">
            <Section className="form-wrapper">
              <Section className="form-group-title">Create User</Section>

              <Section
                className={
                  'form-group' +
                  (this.state.nameValid
                    ? ''
                    : this.state.formValid
                    ? ''
                    : ' is-error')
                }
              >
                <label>Full Name</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      id="fullname"
                      className={
                        this.state.nameValid
                          ? ''
                          : this.state.formValid
                          ? ''
                          : 'is-error'
                      }
                      type="text"
                      name="name"
                      value={this.state.name}
                      onChange={this.handleUserInput}
                    />
                  </Section>

                  <Section className="message">
                    {!this.state.formValid && !this.state.nameValid
                      ? STRING.INVALID
                      : ''}
                  </Section>
                </Section>
              </Section>

              <Section
                className={
                  'form-group' +
                  (this.state.emailValid
                    ? ''
                    : this.state.formValid
                    ? ''
                    : ' is-error')
                }
              >
                <label>Email</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      id="email"
                      className={
                        this.state.emailValid
                          ? ''
                          : this.state.formValid
                          ? ''
                          : 'is-error'
                      }
                      type="text"
                      name="email"
                      value={this.state.email}
                      onChange={this.handleUserInput}
                    />
                  </Section>

                  {this.state.email === '' && (
                    <Section className="message">{STRING.INVALID}</Section>
                  )}
                  {!this.state.emailValid && this.state.email !== '' && (
                    <Section className="message">
                      {STRING.EMAIL_INVALID}
                    </Section>
                  )}

                  {this.state.emailValid && this.state.email !== '' && (
                    <Section className="message">{''}</Section>
                  )}
                </Section>
              </Section>

              <Section
                className={
                  'form-group' +
                  (this.state.phoneValid
                    ? ''
                    : this.state.formValid
                    ? ''
                    : ' is-error')
                }
              >
                <label>Phone</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input
                      id="phone"
                      className={
                        this.state.phoneValid
                          ? ''
                          : this.state.formValid
                          ? ''
                          : 'is-error'
                      }
                      type="text"
                      name="phone"
                      value={this.state.phone}
                      onChange={this.handleUserInput}
                    />
                  </Section>

                  {this.state.phone === '' && (
                    <Section className="message">{STRING.INVALID}</Section>
                  )}
                  {!this.state.phoneValid && this.state.phone !== '' && (
                    <Section className="message">
                      {STRING.PHONE_INVALID}
                    </Section>
                  )}

                  {this.state.phoneValid && this.state.phone !== '' && (
                    <Section className="message">{''}</Section>
                  )}
                </Section>
              </Section>

              <Section
                className={
                  'form-group' + (this.state.roleValid ? ' is-error' : '')
                }
              >
                <label>Role</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <SelectBox
                      id="role"
                      defaultValue={this.state.optionsRoleValue}
                      options={optionsRole}
                      isSearchable={false}
                      isClearable={false}
                      isDisabled={false}
                      onChange={this.handleUserDropdown}
                    />
                  </Section>

                  {this.state.roleValid !== '' && (
                    <Section className="message">{STRING.INVALID}</Section>
                  )}
                </Section>
              </Section>

              {isEditPageState && (
                <Section className="form-group">
                  <label>Active</label>

                  <Section className="form-group-control">
                    <Section className="form-group-inner-wrapper">
                      <Switcher
                        onChange={this.handleChange}
                        checked={isActive}
                      />
                    </Section>

                    <Section className="message"></Section>
                  </Section>
                </Section>
              )}
            </Section>
            <Section
              className={
                'loading' + (this.state.disabledSubmit ? ' show' : ' none')
              }
            >
              <Spinner />
            </Section>
            <Section className="form-actions">
              <Button
                className="theme-border-gray"
                onClick={() => {
                  this.props.history.push(ROUTE_PATH.USER_MANAGEMENT_ADMIN.LINK)
                }}
              >
                Cancel
              </Button>

              <Button
                className="theme-green"
                disabled={this.state.disabledSubmit}
                onClick={this.onFormSubmit}
              >
                Save
              </Button>
            </Section>
          </Section>
        </Section>
      </UserDetailFormAdminStyle>
    )
  }
}
